/* Breezary site header (bzh-): menus, mobile drawer, benefit ticker, scroll behaviour, live cart count */
(function () {
  'use strict';
  var root = document.querySelector('[data-bzh]');
  if (!root || root.__bzh) return;
  root.__bzh = true;
  var desktop = window.matchMedia('(min-width: 1024px)');
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var child = function (el, sel) {
    for (var i = 0; i < el.children.length; i++) if (el.children[i].matches(sel)) return el.children[i];
    return null;
  };

  /* ---------------- mega menus and dropdowns ---------------- */
  var items = root.querySelectorAll('[data-bzh-mega], [data-bzh-dd]');
  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var b = child(item, '[data-bzh-toggle]');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except) {
    each(items, function (it) { if (it !== except && it.classList.contains('is-open')) setOpen(it, false); });
  }
  each(items, function (item) {
    var btn = child(item, '[data-bzh-toggle]');
    var link = child(item, '.bzh-nav__link');
    var timer;
    item.addEventListener('mouseenter', function () {
      if (!mouse.matches || !desktop.matches) return;
      clearTimeout(timer);
      timer = setTimeout(function () { closeAll(item); setOpen(item, true); }, 120);
    });
    item.addEventListener('mouseleave', function () {
      if (!mouse.matches || !desktop.matches) return;
      clearTimeout(timer);
      timer = setTimeout(function () { setOpen(item, false); }, 200);
    });
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      clearTimeout(timer);
      var open = !item.classList.contains('is-open');
      closeAll(item);
      setOpen(item, open);
    });
    if (link) link.addEventListener('click', function (e) {
      // touch screens at desktop width: the first tap opens the menu, the second follows the link
      if (!mouse.matches && !item.classList.contains('is-open')) {
        e.preventDefault();
        closeAll(item);
        setOpen(item, true);
      }
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        setOpen(item, false);
        (btn || link).focus();
        e.stopPropagation();
      }
    });
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !item.contains(e.relatedTarget)) setOpen(item, false);
    });
  });
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------------- search hint: a shorter one on narrow phones ---------------- */
  var q = root.querySelector('.bzh-search__input');
  if (q && q.getAttribute('data-short')) {
    var longHint = q.getAttribute('placeholder'), shortHint = q.getAttribute('data-short');
    var narrow = window.matchMedia('(max-width: 479px)');
    var hint = function () { q.setAttribute('placeholder', narrow.matches ? shortHint : longHint); };
    hint();
    if (narrow.addEventListener) narrow.addEventListener('change', hint); else narrow.addListener(hint);
  }

  /* ---------------- mobile drawer ---------------- */
  var drawer = root.querySelector('[data-bzh-drawer]');
  var burger = root.querySelector('[data-bzh-open]');
  var lastFocus = null;
  function openDrawer() {
    lastFocus = document.activeElement;
    root.classList.add('is-drawer-open');
    document.documentElement.classList.add('bzh-lock');
    burger.setAttribute('aria-expanded', 'true');
    setTimeout(function () { var c = drawer.querySelector('[data-bzh-close]'); if (c) c.focus(); }, 40);
  }
  function closeDrawer() {
    if (!root.classList.contains('is-drawer-open')) return;
    root.classList.remove('is-drawer-open');
    document.documentElement.classList.remove('bzh-lock');
    burger.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer && burger) {
    burger.addEventListener('click', openDrawer);
    each(root.querySelectorAll('[data-bzh-close]'), function (b) { b.addEventListener('click', closeDrawer); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(drawer.querySelectorAll('a[href], button, input'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    var onBp = function (m) { if (m.matches) closeDrawer(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onBp); else desktop.addListener(onBp);
  }
  each(root.querySelectorAll('[data-bzh-acc]'), function (b) {
    b.addEventListener('click', function () {
      var p = document.getElementById(b.getAttribute('aria-controls'));
      var open = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (p) p.hidden = !open;
    });
  });

  /* ---------------- announcement ticker (phones / tablets) ---------------- */
  var ticker = root.querySelector('[data-bzh-ticker]');
  if (ticker) {
    var msgs = ticker.querySelectorAll('.bzh-bar__msg'), cur = 0, paused = false;
    var show = function (n) { msgs[cur].classList.remove('is-active'); cur = n; msgs[cur].classList.add('is-active'); };
    setInterval(function () {
      if (paused || desktop.matches || reduce.matches || msgs.length < 2 || document.hidden) return;
      show((cur + 1) % msgs.length);
    }, 4500);
    ticker.addEventListener('mouseenter', function () { paused = true; });
    ticker.addEventListener('mouseleave', function () { paused = false; });
    ticker.addEventListener('focusin', function (e) {
      paused = true;
      var li = e.target.closest('.bzh-bar__msg');
      if (li && !li.classList.contains('is-active')) show(Array.prototype.indexOf.call(msgs, li));
    });
    ticker.addEventListener('focusout', function () { paused = false; });
  }

  /* ---------------- sticky header: stays pinned, hides while scrolling down ---------------- */
  var sticky = root.querySelector('[data-bzh-sticky]');
  var bar = root.querySelector('.bzh-bar');
  if (sticky) {
    var ph = document.createElement('div');
    ph.setAttribute('aria-hidden', 'true');
    sticky.parentNode.insertBefore(ph, sticky);
    var lastY = window.pageYOffset, queued = false;
    var busy = function () {
      return root.querySelector('.is-open') || root.classList.contains('is-drawer-open') ||
        (sticky.contains(document.activeElement) && document.activeElement.tagName === 'INPUT');
    };
    var update = function () {
      queued = false;
      var y = window.pageYOffset;
      var start = root.getBoundingClientRect().top + y + (bar ? bar.offsetHeight : 0);
      var fixed = y > start;
      if (fixed !== sticky.classList.contains('is-fixed')) {
        ph.style.height = fixed ? sticky.offsetHeight + 'px' : '';
        sticky.classList.toggle('is-fixed', fixed);
      }
      if (!fixed || y < lastY - 4) sticky.classList.remove('is-hidden');
      else if (y > lastY + 4 && y > start + sticky.offsetHeight + 200 && !busy()) sticky.classList.add('is-hidden');
      lastY = y;
    };
    window.addEventListener('scroll', function () { if (!queued) { queued = true; window.requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', function () { if (sticky.classList.contains('is-fixed')) ph.style.height = sticky.offsetHeight + 'px'; });
    update();
  }

  /* ---------------- cart count follows add-to-cart without a page reload ---------------- */
  var counts = root.querySelectorAll('[data-bzh-cart-count]');
  var label = root.querySelector('[data-bzh-cart-label]');
  var setCount = function (n) {
    each(counts, function (el) { el.textContent = n; });
    if (label) label.textContent = n + (n === 1 ? ' item' : ' items') + ' in cart';
    root.classList.toggle('has-cart-items', n > 0);
  };
  setCount(parseInt(counts.length ? counts[0].textContent : '0', 10) || 0);
  if (window.fetch && location.protocol !== 'file:') {
    var refresh = function () {
      window.fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count || 0); })
        .catch(function () {});
    };
    var isCart = function (u) { return /\/cart\/(add|change|update|clear)/.test(String(u || '')); };
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      try { if (isCart(typeof input === 'string' ? input : input && input.url)) p.then(function () { setTimeout(refresh, 150); }); } catch (e) {}
      return p;
    };
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (isCart(u)) this.addEventListener('load', function () { setTimeout(refresh, 150); }); } catch (e) {}
      return nativeOpen.apply(this, arguments);
    };
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }
})();

